import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import * as icons from 'react-bootstrap-icons';

export default function GetAppointmentStatus({ id, className }) {
    const { totalStatuses } = useSelector((state) => ({
        totalStatuses: state.setting.totalStatuses
    }));
    const [status, setStatus] = useState(null);
    useEffect(() => {
        setStatus(null);
    },[])
    useEffect(() => {
        if(totalStatuses && (id || id === 0) ) {
            setStatus(totalStatuses.find(item => {
                if(item.id === id) {
                    return item
                }
            }))
        } else {
            setStatus({
                color: '#7E7E7E',
                name: 'در حال بارگزاری',
                id: -1,
            })
        }
    },[id, totalStatuses])
    return (
        <>
            {
                status &&
                <div className={`flex-row-center-center ${className}`} style={{color: status.color}}>
                    <div className='ms-1'>
                        {status.name}
                    </div>
                    <span>
                        {{
                            0: <icons.CalendarPlusFill color={status.color} size={16}/>,
                            1: <icons.XSquareFill color={status.color} size={16}/>,
                            2: <icons.XCircleFill color={status.color} size={16}/>,
                            3: <icons.TelephoneXFill color={status.color} size={16}/>,
                            4: <icons.CheckSquareFill color={status.color} size={16}/>,
                            5: <icons.DashCircleFill color={status.color} size={16}/>,
                            6: <icons.ClipboardCheckFill color={status.color} size={16}/>,
                            7: <icons.ClockFill color={status.color} size={16}/>,
                        }[id]}
                    </span>
                </div>
            }
        </>
    )
}